<template>
    <div class="listing__category--entry">
        <label class="label">{{title}}<sup>*</sup><span class="description">{{text}}</span></label>
        <select @change="updateMetaValue(object, $event)" class="input--select" :class="{'input--error': validator && validator.error}">
            <option selected disabled>{{$t('page.listing.please_choose')}}</option>
            <template v-for="entry in list" :key="entry.id">
                <option selected v-if="object.id == entry.id" :value="entry.id">{{entry.value}}</option>
                <option v-else :value="entry.id">{{entry.value}}</option>
            </template>
        </select>
        <p v-if="validator && validator.error" class="message--error">{{validator.message}}</p>
    </div>
</template>

<script>
export default {
        name: 'dropdown',
        props: {
            object: {
                type: Object,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            list: {
                type: Object,
                required: true,
            },
            text: {
                type: String,
                required: false,
            },
            validator: {
                type: Object,
                required: false,
            }
        },
        emits: ['update-meta'],
        methods: {
            updateMetaValue(object, event) {
                this.$emit('update-meta', object, event)
            }
        },
    }
</script>